module.exports = __webpack_public_path__ + "static/img/jkzs_jcjg_icon_1.gif";